<div class="date-input-container">
    <input [class.warning] = "isWarning" class ="date-input" type="text" name="date" [(ngModel)]="dateString" #date="ngModel"  (blur)="setDate(dateString)" [disabled] = "!isFieldEnabled">
    <div class="info-wrap">
        <img [src]="dateTooltipIcon"  class = "icon-info" (click)="showDateInfo($event)">
    </div>
    <div *ngIf="isWarning" class="text-warning">{{"val_invalid_date" | translate}}</div>
</div>
